/***
*
*   HELP LINK
*   A '?' beside the page title that opens the help article explaining this
*   page. Renders nothing when the current route has no mapped article.
*
*   It resolves the article from the route itself rather than taking a prop,
*   so it can be mounted once in the app layout instead of being threaded
*   through every view. That matters: the integration settings views and the
*   form builder construct their SurveyJS models in the render body, so
*   anything that re-renders them throws away unsaved answers.
*
*   Always opens in a new tab. Navigating away from a survey-backed settings
*   page loses whatever is typed into it, whichever way the link is rendered.
*
**********/

import React from 'react';
import { useLocation, Icon, ClassHelper } from 'components/lib';
import { HELP_EMBED_ENABLED, slugForPath, helpPath,
  helpPublicUrl } from './help';
import Style from './link.tailwind.js';

export function HelpLink(props){

  const location = useLocation();
  const slug = slugForPath(location?.pathname);

  // no article for this page – show nothing rather than link to a page that
  // doesn't exist. the help centre answers 200 for anything, so a wrong link
  // looks like a working one
  if (!slug)
    return false;

  // with the embed off, /help/:slug renders the FAQ page, so send them to the
  // help centre itself instead of somewhere that ignores the slug
  const url = HELP_EMBED_ENABLED ? helpPath(slug) : helpPublicUrl(slug);

  const linkStyle = ClassHelper(Style, { className: props.className });

  return (
    <a
      className={ linkStyle }
      href={ url }
      target='_blank'
      rel='noopener noreferrer'
      title='Help for this page'
      aria-label='Help for this page (opens in a new tab)'>

      <Icon image='help-circle' color='blue' size={ 16 }/>

    </a>
  );
}
